import React, { FC, useCallback, useState } from "react";
import useControls from "../../hooks/useControls";
import "./Controls.scss";
import { Input } from "antd";

const Controls: FC = () => {
  const {
    scale,
    handleScaleChange,
    incrementScale,
    currentPage,
    handlePageChange,
    pages,
  } = useControls();

  const [inputScaleState, setInputScaleState] = useState(scale * 100);

  // The input is user-editable (onChange) and only commits on blur, so it needs
  // its own state, which has to be re-synced whenever `scale` changes from the
  // outside (the +/- buttons). This is React's documented "adjust state while
  // rendering" pattern: it replaces an effect that did the same thing one paint
  // later, and converges on exactly the same value.
  const [prevScale, setPrevScale] = useState(scale);
  if (prevScale !== scale) {
    setPrevScale(scale);
    setInputScaleState(scale * 100);
  }

  const handleEnterPress = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key.toLowerCase() === "enter") {
        event.preventDefault();
        event.stopPropagation();
        // React types `target` as the generic `EventTarget`; this handler is
        // only ever wired to the scale <Input> below.
        (event.target as HTMLInputElement).blur();
      }
    },
    [],
  );

  return (
    <div className="controls__container">
      <div className="controls__page-container">
        <label>Page:</label>
        <input
          disabled
          type="text"
          value={currentPage}
          onChange={(event) => handlePageChange(Number(event.target.value))}
        />
        <label>/ {pages}</label>
      </div>
      <span className="controls__divider" />
      <div className="controls__size-container">
        <span
          role="button"
          className="controls__button"
          onClick={() => incrementScale(-0.1)}
        >
          <i className="bi-dash-lg controls__button-icon" />
        </span>
        <Input
          type="number"
          value={inputScaleState}
          suffix="%"
          onChange={(event) => setInputScaleState(Number(event.target.value))}
          onBlur={() => handleScaleChange(inputScaleState / 100)}
          onKeyPress={handleEnterPress}
          autoComplete="off"
        />
        <span
          role="button"
          className="controls__button"
          onClick={() => incrementScale(0.1)}
        >
          <i className="bi-plus-lg controls__button-icon" />
        </span>
      </div>
    </div>
  );
};

export default Controls;
